function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import useResizeObserver from 'use-resize-observer/polyfilled';
import { useMedia } from 'use-media';
import GridWrapper from './Grid/GridWrapper';
import GridRow from './Grid/GridRow';
import GridColumn from './Grid/GridColumn';
import Heading from '../typography/Heading';
import ErrorSevere from './Icons/ErrorSevere';
import Info from './Icons/Info';
import WarningImportant from './Icons/WarningImportant';
import TickCircle from './Icons/TickCircle';
import { size } from '../utils/helpers';
var GridRowContainer = styled(GridRow)(_templateObject(), function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  var breakpoints = theme.breakpoints;
  return _ref2 = {}, _ref2["@media (max-width: " + (breakpoints.medium - 1) + "px)"] = {
    flexDirection: 'column'
  }, _ref2;
});
var GridColumnIcon = styled(GridColumn)(_templateObject2(), function (_ref3) {
  var _ref4;

  var theme = _ref3.theme;
  var breakpoints = theme.breakpoints;
  return _ref4 = {}, _ref4["@media (max-width: " + (breakpoints.medium - 1) + "px)"] = {
    padding: 0
  }, _ref4;
});
var IconContainer = styled.div(_templateObject3(), function (_ref5) {
  var theme = _ref5.theme,
      variant = _ref5.variant;
  var colors = theme.colors;
  var backgroundColor;

  switch (variant) {
    case 'error':
      backgroundColor = colors.functionalDimmedError;
      break;

    case 'info':
      backgroundColor = colors.functionalDimmedInfo;
      break;

    case 'alert':
      backgroundColor = colors.functionalDimmedAlert;
      break;

    case 'success':
    default:
      backgroundColor = colors.functionalDimmedSuccess;
  }

  return _extends({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: backgroundColor
  }, size({
    width: '100%',
    height: 135
  }));
});

function Feedback(props) {
  var id = props.id,
      theme = props.theme,
      variant = props.variant,
      children = props.children,
      title = props.title,
      rest = _objectWithoutPropertiesLoose(props, ["id", "theme", "variant", "children", "title"]);

  var breakpoints = theme.breakpoints;

  var _useResizeObserver = useResizeObserver(),
      ref = _useResizeObserver.ref,
      height = _useResizeObserver.height;

  var iconContainerEl = useRef(null);
  var isMedium = useMedia({
    minWidth: breakpoints.medium
  });
  var iconContainerHeight;

  if (isMedium && iconContainerEl.current !== null) {
    var _iconContainerEl$curr = iconContainerEl.current.getBoundingClientRect(),
        iconContainerWidth = _iconContainerEl$curr.width;

    if (height >= iconContainerWidth) {
      iconContainerHeight = iconContainerWidth;
    } else if (height > 135) {
      iconContainerHeight = height;
    }
  }

  var icon;
  var iconColor;

  switch (variant) {
    case 'error':
      icon = ErrorSevere;
      iconColor = 'functionalError';
      break;

    case 'info':
      icon = Info;
      iconColor = 'functionalInfo';
      break;

    case 'alert':
      icon = WarningImportant;
      iconColor = 'functionalAlert';
      break;

    case 'success':
    default:
      icon = TickCircle;
      iconColor = 'functionalSuccess';
  }

  return /*#__PURE__*/React.createElement(GridWrapper, _extends({
    id: id
  }, rest), /*#__PURE__*/React.createElement(GridRowContainer, null, /*#__PURE__*/React.createElement(GridColumnIcon, {
    size: {
      xs: 1,
      m: 4 / 12,
      l: 3 / 12
    },
    mb: {
      xs: 1,
      m: 0
    }
  }, /*#__PURE__*/React.createElement(IconContainer, {
    variant: variant,
    style: {
      height: iconContainerHeight
    },
    ref: iconContainerEl
  }, React.createElement(icon, {
    size: 75,
    color: iconColor,
    id: id + "-icon-" + variant
  }))), /*#__PURE__*/React.createElement(GridColumn, {
    ref: ref,
    auto: true
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h4",
    id: id + "-title"
  }, title), children)));
}

Feedback.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['error', 'info', 'alert', 'success']),
  title: PropTypes.string.isRequired
} : {};
Feedback.defaultProps = {
  variant: 'success'
};
export default withTheme(Feedback);